import { render, staticRenderFns } from "./Reset-Password-Update.vue?vue&type=template&id=52296e6a&scoped=true&"
import script from "./Reset-Password-Update.vue?vue&type=script&lang=js&"
export * from "./Reset-Password-Update.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Password-Update.vue?vue&type=style&index=0&id=52296e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52296e6a",
  null
  
)

export default component.exports